import { setUserDataByUserAPI, logoutUser } from './user.actions'
import {
  loadProfileAndPlaceWithToken,
  loginWithProfile,
} from 'app/auth/authAPI'
import MessageAlert from 'app/components/MessageAlert'
import { errorTypes } from 'commons/error'
import { setSuspendedStatus, clearSuspended } from './suspendStatus.actions'
import { isSuspendError, getSuspendErrorStatus } from 'app/auth/suspendStatus'
import {
  isFreeTierPlaceTeamMemberSignInError,
  teamMemberSignInErrorMessage,
  isRestrictedPlaceTeamMemberSignInError,
} from 'app/auth/paidPlanAccess'
import * as R from 'ramda'

export const LOGIN = 'LOGIN'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SHOW_ERROR_PLAN_END = 'SHOW_ERROR_PLAN_END'
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR'

export function submitLogin(
  { username, password, isKeepMeSignedIn },
  formatMessage,
) {
  return (dispatch) => {
    dispatch({ type: LOGIN })
    dispatch(clearSuspended())
    return loginWithProfile({ username, password, isKeepMeSignedIn })
      .then(({ user, token, place, awsCredential }) => {
        const maModeKey = localStorage.getItem('maModeKey')
        let matchToken = token
        if (!R.isNil(maModeKey)) {
          matchToken = { ...token, maModeKey }
        }
        dispatch(setUserDataByUserAPI(user, matchToken, place, awsCredential))
        return dispatch({
          type: LOGIN_SUCCESS,
        })
      })
      .catch((error) => {
        if (isSuspendError(error)) {
          R.compose(dispatch, setSuspendedStatus, getSuspendErrorStatus)(error)
          return dispatch({ type: LOGIN_ERROR })
        }

        if (isRestrictedPlaceTeamMemberSignInError(error)) {
          dispatch({ type: LOGIN_ERROR, payload: error })
          dispatch(logoutUser())
          return dispatch(
            MessageAlert.showError({
              message: formatMessage({
                id: error.id,
              }),
            }),
          )
        }

        if (isFreeTierPlaceTeamMemberSignInError(error)) {
          dispatch(logoutUser())
          R.compose(
            dispatch,
            (message) => MessageAlert.showError({ message }),
            teamMemberSignInErrorMessage(formatMessage),
          )(error)
          return dispatch({ type: LOGIN_ERROR, payload: error })
        }

        dispatch({ type: LOGIN_ERROR, payload: error })
        if (
          error &&
          error.response.data.status === 503 &&
          error.response.data.details &&
          error.response.data.details.code === 700
        ) {
          return
        }
        dispatch(logoutUser())
        return dispatch(
          MessageAlert.showNetworkError(formatMessage)(error, errorTypes.login),
        )
      })
  }
}

export function login(credentials, formatMessage) {
  return (dispatch) => {
    dispatch({ type: LOGIN })
    dispatch(clearSuspended())
    return loadProfileAndPlaceWithToken(credentials)
      .then(({ user, token, place, awsCredential }) => {
        const maModeKey = localStorage.getItem('maModeKey')
        let matchToken = token
        if (!R.isNil(maModeKey)) {
          matchToken = { ...token, maModeKey }
        }
        dispatch(setUserDataByUserAPI(user, matchToken, place, awsCredential))
        return dispatch({
          type: LOGIN_SUCCESS,
        })
      })
      .catch((error) => {
        if (isSuspendError(error)) {
          R.compose(dispatch, setSuspendedStatus, getSuspendErrorStatus)(error)
          return dispatch({ type: LOGIN_ERROR })
        }

        if (isRestrictedPlaceTeamMemberSignInError(error)) {
          dispatch({ type: LOGIN_ERROR, payload: error })
          dispatch(logoutUser())
          return dispatch(
            MessageAlert.showError({
              message: formatMessage({
                id: error.id,
              }),
            }),
          )
        }

        if (isFreeTierPlaceTeamMemberSignInError(error)) {
          dispatch(logoutUser())
          R.compose(
            dispatch,
            (message) => MessageAlert.showError({ message }),
            teamMemberSignInErrorMessage(formatMessage),
          )(error)
          return dispatch({ type: LOGIN_ERROR, payload: error })
        }

        dispatch({ type: LOGIN_ERROR, payload: error })
        if (
          error &&
          error.response.data.status === 503 &&
          error.response.data.details &&
          error.response.data.details.code === 700
        ) {
          return
        }
        dispatch(logoutUser())
        return dispatch(
          MessageAlert.showNetworkError(formatMessage)(error, errorTypes.login),
        )
      })
  }
}

export function autherRoleHavePlanEnd() {
  return (dispatch) => {
    dispatch({ type: SHOW_ERROR_PLAN_END })
  }
}

export function clearLoginError() {
  return (dispatch) => {
    dispatch({ type: CLEAR_LOGIN_ERROR })
  }
}
